import { PlatformUtils_getInstancezyao53u70tqo as PlatformUtils_getInstance } from '../PlatformUtils.mjs';
import {
  Companion_instancejy2056q2ma5w as Companion_instance,
  _Result___init__impl__xyqfz832zdzqrocazzs as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  _Result___get_value__impl__bjfvqg9vwgdwmhxc4m as _Result___get_value__impl__bjfvqg,
  _Result___get_isFailure__impl__jpiriv2yxkms7bg2hpm as _Result___get_isFailure__impl__jpiriv,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import {
  get_entries3rhsgvbgx7tis as get_entries,
  LogLevel_INFO_getInstance6ydhs90npb5u as LogLevel_INFO_getInstance,
  LogLevel_TRACE_getInstance6wj9jeeq7wzm as LogLevel_TRACE_getInstance,
  LogLevel_WARN_getInstance2ommq0eydh1yh as LogLevel_WARN_getInstance,
  LogLevel_DEBUG_getInstance3qxf80khj7cr8 as LogLevel_DEBUG_getInstance,
} from './Logger.web.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function KtorSimpleLogger(name) {
  return new (KtorSimpleLogger$1())();
}
function getKtorLogLevel() {
  return process ? process.env.KTOR_LOG_LEVEL : null;
}
var KtorSimpleLogger$1Class;
function KtorSimpleLogger$1() {
  if (KtorSimpleLogger$1Class === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        var tmp_0;
        switch (PlatformUtils_getInstance().f4s_1 || PlatformUtils_getInstance().e4s_1) {
          case true:
            // Inline function 'kotlin.runCatching' call

            var tmp_1;
            try {
              // Inline function 'kotlin.Companion.success' call
              var value = getKtorLogLevel();
              tmp_1 = _Result___init__impl__xyqfz8(value);
            } catch ($p) {
              var tmp_2;
              if ($p instanceof Error) {
                var e = $p;
                // Inline function 'kotlin.Companion.failure' call
                tmp_2 = _Result___init__impl__xyqfz8(createFailure(e));
              } else {
                throw $p;
              }
              tmp_1 = tmp_2;
            }

            // Inline function 'kotlin.Result.getOrNull' call

            var this_0 = tmp_1;
            var tmp1_safe_receiver = _Result___get_isFailure__impl__jpiriv(this_0) ? null : _Result___get_value__impl__bjfvqg(this_0);
            var tmp_3;
            if (tmp1_safe_receiver == null) {
              tmp_3 = null;
            } else {
              // Inline function 'kotlin.let' call
              var tmp0 = get_entries();
              var tmp$ret$7;
              $l$block: {
                // Inline function 'kotlin.collections.firstOrNull' call
                var _iterator__ex2g4s = tmp0.p1();
                while (_iterator__ex2g4s.q1()) {
                  var element = _iterator__ex2g4s.r1();
                  if (element.v1_1 === tmp1_safe_receiver) {
                    tmp$ret$7 = element;
                    break $l$block;
                  }
                }
                tmp$ret$7 = null;
              }
              tmp_3 = tmp$ret$7;
            }

            var tmp2_elvis_lhs = tmp_3;
            tmp_0 = tmp2_elvis_lhs == null ? LogLevel_INFO_getInstance() : tmp2_elvis_lhs;
            break;
          case false:
            tmp_0 = LogLevel_TRACE_getInstance();
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        tmp.x4w_1 = tmp_0;
      }
      y4w() {
        return this.x4w_1;
      }
      z4w(message) {
        if (this.x4w_1.e5(LogLevel_WARN_getInstance()) > 0)
          return Unit_instance;
        console.warn(message);
      }
      a4x(message, cause) {
        if (this.x4w_1.e5(LogLevel_DEBUG_getInstance()) > 0)
          return Unit_instance;
        console.debug('DEBUG: ' + message + ', cause: ' + cause.toString());
      }
      b4x(message) {
        if (this.x4w_1.e5(LogLevel_TRACE_getInstance()) > 0)
          return Unit_instance;
        console.debug('TRACE: ' + message);
      }
      c4x(message, cause) {
        if (this.x4w_1.e5(LogLevel_TRACE_getInstance()) > 0)
          return Unit_instance;
        console.debug('TRACE: ' + message + ', cause: ' + cause.toString());
      }
    }
    initMetadataForClass($);
    KtorSimpleLogger$1Class = $;
  }
  return KtorSimpleLogger$1Class;
}
//region block: exports
export {
  KtorSimpleLogger as KtorSimpleLogger1xdphsp5l4e48,
};
//endregion

//# sourceMappingURL=KtorSimpleLogger.web.mjs.map
